import { format } from "date-fns";
import { es } from "date-fns/locale";
import React from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const RetreatItem = ({ retreat }) => {
  return (
    <Col md={4} className="pt-3">
      <Card className="border-0 shadow-sm h-100">
        {/* Image */}
        <div
          style={{
            backgroundImage: `url(${retreat.imageUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "220px",
            borderTopLeftRadius: "0.375rem",
            borderTopRightRadius: "0.375rem",
          }}
        />

        <Card.Body className="text-center px-4 py-4">
          {/* Title */}
          <Card.Title
            className="mb-2"
            style={{
              fontSize: "1.1rem",
              fontWeight: 600,
              letterSpacing: "0.5px",
            }}
          >
            {retreat.title}
          </Card.Title>

          {/* Date range */}
          <Card.Text
            className="mb-4"
            style={{
              fontSize: "0.9rem",
              color: "#666",
            }}
          >
            {format(new Date(retreat.date), "d MMMM", { locale: es })} –{" "}
            {format(new Date(retreat.endDate), "d MMMM", { locale: es })}
          </Card.Text>

          {/* CTA */}
          <Link to={`/retreats/${retreat._id}`}>
            <Button size="sm" className="mainButton px-4">
              Ver más
            </Button>
          </Link>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default RetreatItem;
